import React from 'react'
import { Mail, FileDown } from 'lucide-react'
import { LuFileSpreadsheet } from "react-icons/lu";
import BootstrapModalWrapper from '../CustomModal';

function DownloadModal(props) {
    const { downloadFunction, VehicleDataLength } = props
    const allowedDownloadInDevice = Boolean(VehicleDataLength <= 20 && VehicleDataLength !== 0)
    document.querySelectorAll('.am5-layer, .am5-tooltip-container, .am5-overlay').forEach(el => {
    el.style.pointerEvents = 'none';
    el.style.opacity = 0;
});

    return (
        // <div>
        //     <div>
                <BootstrapModalWrapper id="Download_MSAce_Overview" closeBtn={true}>
                {/* <div id="Download_MSAce_Overview" className="modal"  role="dialog"> */}
                    {/* <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-capitalize fw-bolder">{"Download Reports of all vehicles"}</h5>
                                <button type="button" className="close" data-dismiss="modal">
                                    &times;
                                </button>
                            </div> */}
                            <div className="modal-body px-3" style={{ overflowY: "scroll", height: "230px", }}>
                                {(!allowedDownloadInDevice && VehicleDataLength !== 0) ? <i style={{ fontSize: "10px" }}>Disclaimer: You have selected more than 20 vehicles. The report will be shared via email only.</i> : <></>}
                                <div className={`d-flex justify-content-between my-3 align-items-center  ${!allowedDownloadInDevice ? "disabled-custom" : ""}`} >
                                    <div><LuFileSpreadsheet size={50} color='green' /> Download to device</div>
                                    <button onClick={() => downloadFunction("download")} className='w-25 h-25 btn ms_btn' data-dismiss={`${!allowedDownloadInDevice ? "" : "modal"}`}  >Download</button>
                                </div>
                                <br />
                                <div className={`d-flex justify-content-between align-items-center ${VehicleDataLength == 0 ? "disabled-custom" : ""}`} >
                                    <div><Mail size={50} color="#358696" /> Send to registered Email address</div>
                                    <button onClick={() => downloadFunction("email")} className='w-25 h-25 btn ms_btn' data-dismiss="modal" >Send Email</button>
                                </div>

                            {/* </div>
                        </div> */}
                    </div>
                {/* </div> */}
                  </BootstrapModalWrapper>
        //     </div >
        // </div >
      
    )
}

export default DownloadModal
